(function(){const n=document.createElement("link").relList;if(n&&n.supports&&n.supports("modulepreload"))return;for(const e of document.querySelectorAll('link[rel="modulepreload"]'))i(e);new MutationObserver(e=>{for(const o of e)if(o.type==="childList")for(const c of o.addedNodes)c.tagName==="LINK"&&c.rel==="modulepreload"&&i(c)}).observe(document,{childList:!0,subtree:!0});function s(e){const o={};return e.integrity&&(o.integrity=e.integrity),e.referrerPolicy&&(o.referrerPolicy=e.referrerPolicy),e.crossOrigin==="use-credentials"?o.credentials="include":e.crossOrigin==="anonymous"?o.credentials="omit":o.credentials="same-origin",o}function i(e){if(e.ep)return;e.ep=!0;const o=s(e);fetch(e.href,o)}})();

function _(t,n){
    if(window.el_debug&&console.log("scrollToTargetAdjusted",t,n),typeof t>"u"){
        window.el_debug&&console.log("scrollToTargetAdjusted: element is undefined");
        return;
    }

    if(typeof n>"u") var n=42;

    var s=t.getBoundingClientRect().top,
        i=s+window.scrollY-n;

    window.scrollTo({
        top:i,
        behavior:"smooth"
    });
}

function m(t){
    window.el_debug&&console.log("getScrollToClass",t);

    const s=t.getAttribute("href").replace(/.*#/,"").replace("scroll-to_","");

    return s===""?!1:s;
}

function h(){
    window.el_debug&&console.log("initScrollButtons");

    const t=document.querySelectorAll("._sa-internal-link");

    t.length>0&&t.forEach(n=>{
        window.el_debug&&console.log("initScrollButtons > ",n),
        n.addEventListener("click",function(s){
            const i=m(n);
            i!==!1&&(s.preventDefault(),_(document.querySelector("."+i),50));
        });
    });
}

function v(){
    document.addEventListener("DOMContentLoaded",function(){
        h();
    });
}

function g(t){
    if(typeof t!="string") return !1;

    const n=t.trim();

    return !(n.startsWith("https://")||n.startsWith("http://")||n.substring(0,1)=="/");
}

/*
    Updated v2-button handling.
    Supports:
    - #section-id
    - .section-class
    - legacy class-name-only targets
    - external URLs
*/
function p(){
    for(var t=document.querySelectorAll(".v2-button"),n=0;n<t.length;n++){
        const s=t[n],
            i=s.getAttribute("data-target"),
            e=s.getAttribute("href"),
            o=i??e;

        if(o!=null){
            if(!g(o)){
                o==i&&s.addEventListener("click",function(l){
                    l.preventDefault("external click");

                    const r=o;

                    window.open(r,"_blank").focus();
                });

                continue;
            }

            s.addEventListener("click",function(l){
                const r=this.getAttribute("data-target"),
                    a=this.getAttribute("href"),
                    d=r??a;

                if(!g(d)){
                    window.open(d,"_blank");
                    return;
                }

                if(!d||d==="#"){
                    return;
                }

                let u=null;

                if(d.startsWith("#")){
                    u=document.querySelector(d);
                } else if(d.startsWith(".")){
                    u=document.querySelector(d);
                } else {
                    u=document.querySelector("."+d);
                }

                if(u){
                    l.preventDefault();
                    scrollToTargetAdjusted(u,50);
                } else {
                    console.info("StudyActive Section Steps > Target element not found:",d);
                }
            });
        }
    }
}

function L(){
    document.addEventListener("DOMContentLoaded",function(){
        setTimeout(function(){
            p();
        },250);
    });
}

const f=!1;

function w(){
    document.addEventListener("DOMContentLoaded",function(){
        setTimeout(()=>{
            document.querySelectorAll("header header-menu details").forEach(t=>{
                const n=t.getAttribute("id");

                t.addEventListener("click",function(s){
                    const i=n,
                        e=document.querySelector("#"+i+" summary"),
                        o=e.classList.contains("_sa-hovering"),
                        c=e.classList.contains("_sa-clicked"),
                        l=s.target.closest(".v2-mm-wrapper")!=null,
                        r=e.classList.contains("open");

                    f&&console.log(t.getAttribute("open"));

                    const a=e.classList.contains("_sa-just-hovered"),
                        d=window.innerWidth<=750;

                    e&&!d&&!l&&(
                        a
                            ? e.classList.remove("_sa-just-hovered")
                            : (
                                document.querySelectorAll("header header-menu summary").forEach(u=>{
                                    u!==e&&(
                                        u.classList.remove("_sa-clicked"),
                                        u.classList.remove("_sa-hovering"),
                                        u.classList.remove("_sa-just-hovered")
                                    );
                                }),
                                o&&s.preventDefault(),
                                c
                                    ? e.classList.remove("_sa-clicked")
                                    : (
                                        e.classList.add("_sa-clicked"),
                                        e.classList.add("_sa-hovering")
                                    )
                            )
                    );
                });

                t.addEventListener("mouseenter",function(s){
                    f&&console.log("mouseenter");

                    const i=n,
                        e=document.querySelector("#"+i+" summary"),
                        o=e.classList.contains("_sa-hovering"),
                        c=e.classList.contains("_sa-clicked"),
                        l=window.innerWidth<=750,
                        r=t.getAttribute("open")=="",
                        a=!r&&o;

                    f&&console.log(
                        "Open: ",
                        t.getAttribute("open"),
                        "haz_open: "+(r?"true":"false"),
                        "iz_hovering: "+(o?"true":"false"),
                        "iz_clicked: "+(c?"true":"false"),
                        "lost_focus: "+(a?"true":"false")
                    );

                    e&&!l&&(!c||a)&&(
                        a&&e.classList.remove("_sa-clicked"),
                        r||(
                            e.classList.add("_sa-hovering"),
                            e.classList.add("_sa-just-hovered"),
                            e.click()
                        )
                    );
                });

                t.addEventListener("mouseleave",function(s){
                    f&&console.log("mouseleave");

                    const i=n,
                        e=document.querySelector("#"+i+" summary"),
                        o=e.classList.contains("_sa-hovering"),
                        c=e.classList.contains("_sa-clicked"),
                        l=window.innerWidth<=750,
                        r=t.getAttribute("open")=="";

                    f&&console.log(
                        "Open: ",
                        t.getAttribute("open"),
                        "haz_open: "+(r?"true":"false"),
                        "iz_hovering: "+(o?"true":"false"),
                        "iz_clicked: "+(c?"true":"false")
                    );

                    e&&!l&&(
                        c||r&&(
                            e.classList.remove("_sa-hovering"),
                            e.classList.add("_sa-just-hovered"),
                            e.click()
                        )
                    );
                });
            });
        },500);
    });
}

window.el_debug=!1;

typeof window<"u"&&(window.scrollToTargetAdjusted=_);

v();
L();
w();